<template>
  <div class="ap-address">
    <div class="address-list" v-show="!$route.params.id">
      <div class="page-inner-header">
        <div class="page-inner-title float-left">收货地址管理</div>
        <button class="ap-btn-red ap-btn-red-hover1 float-right" @click="showDialog(null)">新建地址</button>
      </div>
      <div>
        <table style="cursor:pointer" class="table table-hover font12">
          <thead>
            <tr>
              <th class="col1">区域</th>
              <th>收货地址</th>
              <th class="col3" style="width:120px">收货人姓名</th>
              <th class="col4" style="width:140px">联系手机</th>
              <th class="col5" style="width:140px">创建时间</th>
              <th style="width:120px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(it,idx) in addressInfos" :key="idx">
              <td>{{it.locationShowingName}}</td>
              <td>{{it.detail}}</td>
              <td>{{it.linkman}}</td>
              <td>{{it.mobileNumber}}</td>
              <td>{{it.createdTime | toShortDateTime}}</td>
              <td class="text-center">
                <a class="btn btn-sm btn-icon btn-secondary" @click="showDialog(it)">
                  <i class="fa fa-pencil-alt"></i>
                  <span class="sr-only">Edit</span>
                </a>
                <a class="btn btn-sm btn-icon btn-secondary" style="margin-left:10px" @click="remove(it.idx)">
                  <i class="far fa-trash-alt"></i>
                  <span class="sr-only">Remove</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Dialog title="新建收货地址" @callback="save" ref="dialog">
      <strong>所在区域</strong>
      <div style="margin:10px 0 20px;display:flex;height:36px;">
        <AutoComplete style="flex:1;" @change="changeProvince" placeholder="省份">
          <option value></option>
          <option v-for="it in provinces" :value="it.sourceId" :key="it.sourceId" :selected="it.sourceId == provinceId">{{it.name}}</option>
        </AutoComplete>
        <AutoComplete style="flex:1;margin: 0 10px;" @change="changeCity" placeholder="市">
          <option value></option>
          <option v-for="it in cities" :value="it.sourceId" :key="it.sourceId" :selected="it.sourceId == cityId">{{it.name}}</option>
        </AutoComplete>
        <AutoComplete style="flex:1;" @change="changeRegion" placeholder="区县">
          <option value></option>
          <option v-for="it in regions" :value="it.id" :key="it.id" :selected="it.id == regionId">{{it.name}}</option>
        </AutoComplete>
      </div>
      <strong>详细地址</strong>
      <div class="clearfix" style="margin:10px 0 20px;">
        <input class="form-control float-left" placeholder="街道，建筑物门牌号" v-model="detail" />
      </div>
      <strong>收货人</strong>
      <div class="clearfix" style="margin:10px 0 20px;">
        <input class="form-control float-left" placeholder="姓名" style="width:140px; margin-right:20px" v-model="linkman" />
        <input type="number" class="form-control float-left" placeholder="手机号码" style="width:305px" v-model="mobileNumber" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";
import Dialog from "@components/Dialog.vue";
import AutoComplete from "@components/AutoComplete.vue";
export default {
  components: {
    Pagination,
    Dialog,
    AutoComplete
  },
  data() {
    return {
      addressInfos: [],
      pageIndex: 1,
      addrIdx: -1,
      provinces: [],
      provinceId: "",
      cities: [],
      cityId: "",
      regions: [],
      regionId: "",
      locationId: "",
      detail: "",
      linkman: "",
      mobileNumber: ""
    };
  },
  created() {
    this.getOrgPro();
    document.title = "51 AUTOPARTS 收货地址管理";
  },
  mounted() {
    this.$refs.dialog.close();
  },
  methods: {
    getOrgPro() {
      this.$get("/spms/myProfiles/getOrgProfile/")
        .then(res => {
          this.addressInfos = res.addressInfos.filter(x => "DELIVERY" == x.type);
        })
        .catch(err => {});
    },
    showDialog(item) {
      this.provinceId = "";
      this.provinces = [];
      this.cityId = "";
      this.cities = [];
      this.regionId = "";
      this.regions = [];
      this.addrIdx = -1;
      this.detail = "";
      this.linkman = "";
      this.mobileNumber = "";
      if (item) {
        let locationIds = item.locationPathIndex.split(",");
        this.detail = item.detail;
        this.linkman = item.linkman;
        this.mobileNumber = item.mobileNumber;
        this.changeProvince(locationIds[1]);
        this.changeCity(locationIds[2]);
        this.changeRegion(item.locationId + "_" + item.locationVn);
        this.addrIdx = item.idx;
      }
      this.getProvinces();
      this.$refs.dialog.show();
    },
    save() {
      if (!this.regionId) return $msg.warning("请选择所在区域");
      if (!this.detail) return $msg.warning("请填写详细地址");
      if (!this.linkman) return $msg.warning("请填写收货人姓名");
      if (!this.mobileNumber) return $msg.warning("请填写收货人手机号码");
      let args = {
        type: "DELIVERY",
        detail: this.detail,
        locationId: this.regionId,
        linkman: this.linkman,
        mobileNumber: this.mobileNumber
      };
      if (this.addrIdx >= 0) args.idx = this.addrIdx;
      this.$post("/spms/myProfiles/saveOrgAddr", args)
        .then(res => {
          this.getOrgPro();
          this.$refs.dialog.close();
        })
        .catch(err => {});
    },
    remove(idx) {
      $alert({
        type: "remove",
        title: "确定删除吗？",
        text: "一旦删除将无法恢复，请确定是否继续。",
        ok: () => {
          this.$post("/spms/myProfiles/removeOrgAddr/", { idx })
            .then(res => this.getOrgPro())
            .catch(err => {});
        }
      });
    },
    getProvinces() {
      this.$list("/dmhs/locations/query/")
        .then(res => (this.provinces = res))
        .catch(err => {});
    },
    changeProvince(v) {
      this.provinceId = v;
      this.cityId = "";
      this.regionId = "";
      this.cities = [];
      this.regions = [];
      this.getCities();
    },
    getCities() {
      this.$list("/dmhs/locations/query/", { parentId: this.provinceId })
        .then(res => (this.cities = res))
        .catch(err => {});
    },
    changeCity(v) {
      this.cityId = v;
      this.regionId = "";
      this.regions = [];
      this.getRegions();
    },
    getRegions() {
      this.$list("/dmhs/locations/query/", { parentId: this.cityId })
        .then(res => (this.regions = res))
        .catch(err => {});
    },
    changeRegion(v) {
      this.regionId = v;
    }
  }
};
</script>

<style lang="less">
.ap-address {
  padding: 20px;
  background: #fff;
  .address-list {
    .table {
      tbody {
        color: #666;
      }
    }
    .col1 {
      width: 306px;
      span,
      a {
        display: inline-block;
        vertical-align: top;
      }
      span + span {
        margin-left: 25px;
      }
      a {
        margin-left: 5px;
        width: 100px;
        color: #09c;
        text-align: left;
        &:hover {
          color: #09c;
          text-decoration: underline;
        }
      }
    }
    .col3 {
      width: 150px;
    }
    .col4 {
      width: 114px;
    }
    .col5 {
      width: 126px;
      button {
        padding-top: 2px !important;
        padding-bottom: 2px !important;
      }
    }
  }
}
</style>